import { BoxProps, Stack, StackProps } from "@mui/material";
import { forwardRef } from "react";

export interface ViewContentBlockProps extends StackProps {
  variant?: "standard" | "one-sided";
  sx?: BoxProps["sx"];
}

export default forwardRef<HTMLDivElement, ViewContentBlockProps>(function ViewContentBlock(
  { variant = "standard", children, sx, ...otherProps }: ViewContentBlockProps,
  ref,
) {
  const isOneSided = variant === "one-sided";

  return (
    <Stack
      ref={ref}
      data-testid='ViewContentBlock'
      className={`ViewContentBlock ${isOneSided ? "ViewContentBlock--onesided" : ""}`}
      sx={{
        p: 1.25,
        gap: 1.25,
        backgroundColor: (t) =>
          isOneSided ? t.palette.background.default : t.palette.background.paper,

        ...(!(sx as any)?.borderRadius && {
          borderRadius: (t) => t.shapeCustom.borderRadiusCard,
          borderTopLeftRadius: (t) => (isOneSided ? "2px" : t.shapeCustom.borderRadiusCard),
          borderBottomLeftRadius: (t) => (isOneSided ? "2px" : t.shapeCustom.borderRadiusCard),
          borderLeft: (t) => (isOneSided ? `2px solid ${t.palette.divider}` : `none`),
        }),

        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Stack>
  );
});
